import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";

export const getErrorMessage = (
  error: FetchBaseQueryError | SerializedError | undefined
) => {
  if (isFetchBaseQueryError(error)) {
    const fetchBaseQueryError = JSON.parse(JSON.stringify(error));
    return "error" in fetchBaseQueryError
      ? fetchBaseQueryError.error
      : fetchBaseQueryError.data?.message;
  } else if (isErrorWithMessage(error)) {
    return error.message;
  } else return "Sorry, something went wrong, please try again later!";
};

/**
 * Type predicate to narrow an unknown error to `FetchBaseQueryError`
 */
const isFetchBaseQueryError = (
  error: unknown
): error is FetchBaseQueryError => {
  return typeof error === "object" && error != null && "status" in error;
};

/**
 * Type predicate to narrow an unknown error to an object with a string 'message' property
 */
const isErrorWithMessage = (error: unknown): error is { message: string } => {
  return (
    typeof error === "object" &&
    error != null &&
    "message" in error &&
    typeof (error as any).message === "string"
  );
};
